import "core-js/modules/es.array.reverse.js";
var _class, _ApiTableStratum, _class2, _descriptor, _descriptor2, _ApiTableCatalogItem;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import dateFormat from "dateformat";
import { get as _get, map as _map } from "lodash-es";
import { computed, observable, runInAction, makeObservable } from "mobx";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import loadJson from "../../../Core/loadJson";
import AutoRefreshingMixin from "../../../ModelMixins/AutoRefreshingMixin";
import TableMixin from "../../../ModelMixins/TableMixin";
import TableAutomaticStylesStratum from "../../../Table/TableAutomaticStylesStratum";
import ApiTableCatalogItemTraits from "../../../Traits/TraitsClasses/ApiTableCatalogItemTraits";
import TableStyleTraits from "../../../Traits/TraitsClasses/Table/StyleTraits";
import TableTimeStyleTraits from "../../../Traits/TraitsClasses/Table/TimeStyleTraits";
import CreateModel from "../../Definition/CreateModel";
import createStratumInstance from "../../Definition/createStratumInstance";
import LoadableStratum from "../../Definition/LoadableStratum";
import saveModelToJson from "../../Definition/saveModelToJson";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
export let ApiTableStratum = (_class = (_ApiTableStratum = class ApiTableStratum extends LoadableStratum(ApiTableCatalogItemTraits) {
  duplicateLoadableStratum(model) {
    return new ApiTableStratum(model);
  }
  constructor(catalogItem) {
    super();
    this.catalogItem = catalogItem;
    makeObservable(this);
  }

  // Set time id columns to `idKey`
  get defaultStyle() {
    return createStratumInstance(TableStyleTraits, {
      time: createStratumInstance(TableTimeStyleTraits, {
        idColumns: this.catalogItem.idKey ? [this.catalogItem.idKey] : undefined
      })
    });
  }
}, _defineProperty(_ApiTableStratum, "stratumName", "apiTable"), _ApiTableStratum), _applyDecoratedDescriptor(_class.prototype, "defaultStyle", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultStyle"), _class.prototype), _class);
StratumOrder.addLoadStratum(ApiTableStratum.stratumName);
/**
 * THE API AND TRAITS OF THIS EXPERIMENTAL CATALOG ITEM SHOULD BE CONSIDERED IN
 * ALPHA. EXPECT BREAKING CHANGES.
 *
 * This is a generic, one-size-fits-most catalog item for deriving tables from
 * external APIs. Currently only supports JSON APIs, and doesn't support region
 * mapping. Also currently only supports a single API to get values from, and a
 * single API to get positions from.
 */
export let ApiTableCatalogItem = (_class2 = (_ApiTableCatalogItem = class ApiTableCatalogItem extends AutoRefreshingMixin(TableMixin(CreateModel(ApiTableCatalogItemTraits))) {
  get type() {
    return ApiTableCatalogItem.type;
  }
  constructor(id, terria) {
    super(id, terria);
    _initializerDefineProperty(this, "apiResponses", _descriptor, this);
    _initializerDefineProperty(this, "hasData", _descriptor2, this);
    makeObservable(this);
    this.strata.set(TableAutomaticStylesStratum.stratumName, new TableAutomaticStylesStratum(this));
    this.strata.set(ApiTableStratum.stratumName, new ApiTableStratum(this));
  }
  get apiDataIsLoaded() {
    return this.apiResponses.length > 0;
  }
  loadDataFromApis() {
    const apisWithUrl = this.apis.filter(api => api.url);
    const apiUrls = apisWithUrl.map(api => proxyCatalogItemUrl(this, this.addQueryParams(api)));
    return Promise.all(apisWithUrl.map(async (api, idx) => {
      let data = await loadJson(apiUrls[idx], undefined, api.requestData ? saveModelToJson(api.requestData) : undefined, api.postRequestDataAsFormData);
      if (api.responseDataPath !== undefined) {
        data = getResponseDataPath(data, api.responseDataPath);
      }
      return Promise.resolve({
        data,
        api
      });
    })).then(values => {
      runInAction(() => {
        const columnMajorData = new Map();
        values.filter(val => val.api.kind === "COLUMN_MAJOR") // column major rows only
        .map((val, i) => {
          // add the column name to each column
          val.data["TERRIA_columnName"] = val.api.columnMajorColumnNames[i];
          return val.data;
        }).flat()
        // make row id/data pairs for columnMajorData map
        .map(data => Object.entries(data)).flat()
        // merge rows with the same id
        .forEach(rowPart => {
          const id = rowPart[0];
          const value = rowPart[1];
          const row = {};
          row["value"] = value; // add the id to the row's data
          row[this.idKey] = id;
          if (columnMajorData.has(id)) {
            const currentRow = columnMajorData.get(id);
            columnMajorData.set(id, _objectSpread({
              currentRow
            }, value));
          } else {
            columnMajorData.set(id, row);
          }
        });
        if (columnMajorData.size !== 0) {
          this.apiResponses = Array.from(columnMajorData.values());
          return;
        }

        // Make map of ids to values that are constant for that id
        const perIdData = new Map(values.filter(val => val.api.kind === "PER_ID") // per id only
        .map(val => val.data) // throw away api, keep data
        .reduce((curr, prev) => curr.concat(prev), []) // flatten
        // make id/data pair for perIdData map
        .map(data => [data[this.idKey], data]));

        // Merge PER_ID data with *all* PER_ROW data (this may result in the same PER_ID data row being added to multiple PER_ROW data row)
        const perRowData = values.filter(val => val.api.kind === "PER_ROW").map(val => val.data).reduce((curr, prev) => curr.concat(prev), []).map(row => Object.assign(row, isDefined(row[this.idKey]) ? perIdData.get(row[this.idKey]) : {}));
        this.apiResponses = perRowData;
      });
    });
  }
  makeTableColumns(addHeaders) {
    return this.columns.map(col => {
      var _col$name;
      return addHeaders ? [(_col$name = col.name) !== null && _col$name !== void 0 ? _col$name : ""] : [];
    });
  }
  apiResponseToTable() {
    const columnMajorTable = this.makeTableColumns(!this.hasData);
    if (!this.apiDataIsLoaded) {
      // No data yet, just return the headers
      return columnMajorTable;
    }
    // Fill in column values from the API response
    this.apiResponses.forEach(response => {
      this.columns.forEach((col, mappingIdx) => {
        var _this$apiColumns$find;
        if (!isDefined(col.name)) return;

        // If ApiColumnTraits has a responseDataPath, use that to get the value
        const dataPath = (_this$apiColumns$find = this.apiColumns.find(c => c.name === col.name)) === null || _this$apiColumns$find === void 0 ? void 0 : _this$apiColumns$find.responseDataPath;
        if (dataPath) {
          var _getResponseDataPath;
          columnMajorTable[mappingIdx].push("".concat((_getResponseDataPath = getResponseDataPath(response, dataPath)) !== null && _getResponseDataPath !== void 0 ? _getResponseDataPath : ""));
        }
        // Otherwise, use column name as the path
        else {
          var _response$col$name;
          columnMajorTable[mappingIdx].push("".concat((_response$col$name = response[col.name]) !== null && _response$col$name !== void 0 ? _response$col$name : ""));
        }
      });
    });
    return columnMajorTable;
  }
  async forceLoadMetadata() {
    return Promise.resolve();
  }
  async forceLoadTableData() {
    return this.loadDataFromApis().then(() => {
      runInAction(() => {
        const newTableData = this.apiResponseToTable();
        if (this.shouldAppendNewData) {
          this.append(newTableData);
        } else {
          this.dataColumnMajor = newTableData;
        }
        this.hasData = true;
      });
    }).then(() => undefined);
  }
  refreshData() {
    this.loadDataFromApis().then(() => {
      runInAction(() => {
        const newTableData = this.apiResponseToTable();
        if (this.shouldAppendNewData) {
          this.append(newTableData);
        } else {
          this.dataColumnMajor = newTableData;
        }
      });
    });
  }
  addQueryParams(api) {
    const uri = new URI(api.url);
    const substituteDateTimesInQueryParam = param => {
      if (param.startsWith("DATE!")) {
        const dateFormatString = param.slice(param.indexOf("!") + 1);
        const now = new Date();
        return dateFormat(now, dateFormatString);
      }
      return param;
    };

    // Add common query parameters
    let useUpdateParams = this.hasData && this.updateQueryParameters.length > 0;
    const commonQueryParameters = useUpdateParams ? this.updateQueryParameters : this.queryParameters;
    commonQueryParameters.forEach(query => {
      uri.addQuery(query.name, substituteDateTimesInQueryParam(query.value));
    });

    // Add API-specific query parameters
    useUpdateParams = this.hasData && api.updateQueryParameters.length > 0;
    const specificQueryParameters = useUpdateParams ? api.updateQueryParameters : api.queryParameters;
    specificQueryParameters.forEach(query => {
      uri.addQuery(query.name, substituteDateTimesInQueryParam(query.value));
    });
    return uri.toString();
  }
}, _defineProperty(_ApiTableCatalogItem, "type", "api-table"), _ApiTableCatalogItem), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "apiResponses", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "hasData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "apiDataIsLoaded", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "apiDataIsLoaded"), _class2.prototype), _class2);

/**
 * Return the value at json path of the data object.
 *
 * This works exactly like the lodash.get() function but adds support for
 * traversing array objects.  For eg, the lodash.get() does not support a path
 * like: `a.users[].name`, but this function will correctly return a `{name}[]`
 * array if they exist. The particular syntax for array traversal
 * is borrowed from `jq` CLI tool.
 */
function getResponseDataPath(data, jsonPath) {
  // Split the path at `[].` or `[]`
  const pathSegments = jsonPath.split(/\[\]\.?/);
  const getPath = (data, path) => path === "" ? data : Array.isArray(data) ? _map(data, path) : _get(data, path);
  return pathSegments.reduce((nextData, segment) => getPath(nextData, segment), data);
}
StratumOrder.addLoadStratum(TableAutomaticStylesStratum.stratumName);